import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { Form, Button, Table, InputGroup, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { adminInstance } from "../../services/axiosInstance";
import formatDateForInput from "../../services/CommonServices/dateService";

function ServiceRequestReportPage() {
    const hierarchy = sessionStorage.getItem('role');
    const [request, setRequest] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setdata] = useState([]);
    const [fromDate, setFromDate] = useState(formatDateForInput(new Date()));
    const [toDate, setToDate] = useState(formatDateForInput(new Date()));

    const SERVICE_TYPES = {
        DEMO: { label: 'Demo Request', color: 'primary' },
        WARRANTY: { label: 'Warranty Request', color: 'success' },
        SHORT_SUPPLY: { label: 'Short Supply', color: 'warning' },
        FOC_GOODWILL: { label: 'FOC-Goodwill', color: 'secondary' },
        SERVICE: { label: 'Service Invoice Request', color: 'info' }
    };

    const STATUS_CONFIG = {
        Open: { label: 'Open', color: 'warning' },
        "Pending With Manager": { label: 'Pending Approval', color: 'warning' },
        "Pending With MD": { label: 'Approved', color: 'warning' },
        "Pending With Commercial": { label: 'Rejected', color: 'warning' },
        Completed: { label: 'Completed', color: 'success' }
    };

    const getStatusBadge = (status) => {
        const config = STATUS_CONFIG[status] || { label: status, color: 'secondary' };
        return <Badge bg={config.color}>{config.label}</Badge>;
    };

    useEffect(() => {
        fetchReport();
    }, []);

    const fetchReport = async () => {
        try {
            debugger;
            var obj = {
                REP_FROM: fromDate,
                REP_TO: toDate
            }
            const response = await adminInstance.post(`servicerequest/GetReport`, obj);
            setRequest(response.data || []);
            setdata(response.data || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
        }
    };

    const exportReport = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

        // Write Excel File
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });


        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "ReimbursementReport-" + getFormattedDate() + ".xlsx");
    }

    const getFormattedDate = () => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        return (
            pad(now.getDate()) +
            pad(now.getMonth() + 1) +
            now.getFullYear() +
            pad(now.getHours()) +
            pad(now.getMinutes()) +
            pad(now.getSeconds())
        );
    }

    const navigate = useNavigate();

    const handleView = (reqId) => {
        var urlName = "MyExpenseRequestDetail";
        navigate(`/${urlName}/${reqId}`);
    }

    const filteredData = data
        .filter(spare =>
            spare.EMP_NAME?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            spare.TRAVEL_TYPE?.toLowerCase().includes(searchTerm.toLowerCase())
        );

    return (
        <>

            <>
                <div className="card aon-card">
                    <div className="card-header aon-card-header">
                        <h4>
                            Service Request Report
                        </h4>
                    </div>
                    <div className="card-body aon-card-body">
                        {
                            <div className="sf-bs-data-table">
                                <div>

                                <div className="d-flex align-items-end mb-3" style={{ gap: '1rem' }}>
                                    <Form.Group controlId="fromDate">
                                        <Form.Label>From</Form.Label>
                                        <Form.Control
                                                type="date"
                                                value={fromDate}
                                            onChange={e => {
                                                const from = e.target.value;
                                                setFromDate(from);
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="toDate">
                                        <Form.Label>To</Form.Label>
                                        <Form.Control
                                                type="date"
                                                value={toDate}
                                            onChange={e => {
                                                const to = e.target.value;
                                                setToDate(to);
                                            }}
                                        />
                                    </Form.Group>
                                    <Button
                                            variant="primary"
                                            onClick={() => fetchReport()}
                                    >
                                        Submit
                                        </Button>
                                        <Button
                                            variant="primary"
                                            onClick={() => exportReport()}
                                        >
                                            Export
                                        </Button>
                                </div>
                                </div>
                                <div className="table-responsive">
                                    {/* Not  */}
                                    <table className="table table-striped table-bordered example-dt-table aon-booking-table responsive" style={{ width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Date</th>
                                                <th>Type</th>
                                                <th>Employee</th>
                                                <th>Customer Code</th>
                                                <th>Customer Name</th>
                                                <th>Item Code</th>
                                                <th>Item Name</th>
                                                <th>Total Amount</th>
                                                <th>Status</th>

                                                <th>Spare Code</th>
                                                <th>Spare Desc</th>
                                                <th>Unit Price</th>
                                                <th>Qty</th>
                                                <th>Amount</th>

                                                <th>SO Number</th>
                                                <th>Invoice No</th>
                                                <th>Invoice Date</th>
                                                <th>Courier</th>
                                                <th>LR Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr >
                                                <td colSpan={21}>
                                                    <InputGroup className="mb-3">
                                                        <Form.Control
                                                            placeholder="Search request..."
                                                            value={searchTerm}
                                                            onChange={e => setSearchTerm(e.target.value)}
                                                        />
                                                    </InputGroup>
                                                </td>
                                            </tr>
                                            {
                                                filteredData?.map((emp, index) => {
                                                    return (
                                                        <tr key={uuidv4()}>
                                                            <td>{emp.ID}</td>
                                                            <td>{new Date(emp.REQ_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td><Badge
                                                                bg={SERVICE_TYPES[emp.REQ_TYPE]?.color || 'primary'}
                                                                className="px-3 py-2"
                                                            >
                                                                {SERVICE_TYPES[emp.REQ_TYPE]?.label}
                                                            </Badge></td>
                                                            <td>{"[" + emp.EMP_ID + "] " + emp.EMP_NAME}</td>
                                                            <td>{emp.CUS_CODE}</td>
                                                            <td>{emp.CUS_NAME}</td>
                                                            <td>{emp.ITEM_CODE}</td>
                                                            <td>{emp.ITEM_DESC}</td>
                                                            <td>{emp.TOTAL_AMOUNT}</td>
                                                            <td>{getStatusBadge(emp.REQ_STATUS)}</td>   

                                                            <td>{emp.SPARE_CODE}</td>
                                                            <td>{emp.SPARE_DESC}</td>
                                                            <td>{emp.UNIT_PRICE}</td>
                                                            <td>{emp.QTY}</td>
                                                            <td>{emp.AMOUNT}</td>

                                                            <td>{emp.SO_NO}</td>
                                                            <td>{emp.INV_NO}</td>
                                                            <td>{new Date(emp.INV_DATE).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                            })}</td>
                                                            <td>{emp.COURIER_NAME}</td>
                                                            <td>{emp.LR_NO}</td>
                                                            {/*<td>{emp.APPROVALS}</td>*/}
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>

        </>
    );
}

export default ServiceRequestReportPage;
